import { render, staticRenderFns } from "./NoMembers.vue?vue&type=template&id=1f171147"
import script from "./NoMembers.vue?vue&type=script&lang=js"
export * from "./NoMembers.vue?vue&type=script&lang=js"
import style0 from "./NoMembers.vue?vue&type=style&index=0&id=1f171147&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f171147')) {
      api.createRecord('1f171147', component.options)
    } else {
      api.reload('1f171147', component.options)
    }
    module.hot.accept("./NoMembers.vue?vue&type=template&id=1f171147", function () {
      api.rerender('1f171147', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/price/NoMembers.vue"
export default component.exports